import {createElement} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {setRuntimeMenuState, toggleRuntimeMenuState} from '../../../../../redux/actions/runtime/menu';
import {menuStateSelector} from '../../../../../redux/selectors/runtime/menu';
import {Props} from './model';
import View from './view';

export const DropdownMenu = (props: Props) => {
  const isActive = useSelector(menuStateSelector());
  const dispatch = useDispatch();
  return createElement(View, {
    ...props,
    isActive,
    onClick: () => {
      dispatch(toggleRuntimeMenuState());
    },
    close: () => {
      dispatch(setRuntimeMenuState(false));
    },
  });
};
